module.exports = __webpack_public_path__ + "static/media/usa-img02.f284fcf0.jpg";